import { Temporal } from "@js-temporal/polyfill";
import React from "react";
import ReactDOM from "react-dom/client";
// SIMS-8351 (FR-8): self-host Roboto. The app had NO webfont at all — index.css listed Roboto fourth
// in the body stack (after -apple-system and Segoe UI) and the MUI theme left fontFamily unset while
// its own comment claimed "Roboto by default", so Roboto never actually rendered. The certificate's
// "Match body text" option resolves to the certificate body font, which the hand-off draws in Roboto,
// so it has to be present and not silently substituted — and a bundled face is also what makes the
// PDF reliable (html2canvas awaits document.fonts.ready before rasterising).
// woff2 subsets, ~15-30KB per weight, rather than the design system's ~994KB variable TTFs.
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
	AppState,
	Auth0Provider,
	Auth0ProviderOptions,
} from "@auth0/auth0-react";
import { getConfig } from "./config";
import history from "./utils/history";

// Make Temporal available globally
declare global {
	// eslint-disable-next-line @typescript-eslint/no-namespace
	namespace globalThis {
		// eslint-disable-next-line no-var
		var Temporal: typeof import("@js-temporal/polyfill").Temporal;
	}
}
globalThis.Temporal = Temporal;

const onRedirectCallback = (appState: AppState | undefined) => {
	history.push(
		appState && appState.returnTo
			? appState.returnTo
			: window.location.pathname,
	);
};

// Please see https://auth0.github.io/auth0-react/interfaces/Auth0ProviderOptions.html
// for a full list of the available properties on the provider
const config = getConfig();

const providerConfig: Auth0ProviderOptions = {
	domain: config.domain,
	clientId: config.clientId,
	onRedirectCallback,
	authorizationParams: {
		organization: config.organization,
		redirect_uri: `${window.location.origin}/callback`,
		...(config.audience ? { audience: config.audience } : null),
	},
	useRefreshTokens: true,
	cacheLocation: "localstorage",
};

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);
root.render(
	<React.StrictMode>
		<Auth0Provider {...providerConfig}>
			<App />
		</Auth0Provider>
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
